import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import MenuPersonasSSV from './MenuPersonasSSV';
import { useAuth } from '../../Auth/AuthContext';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useForm } from 'react-hook-form';
import { Card, CardHeader, CardBody, CardFooter, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import { FaSave, FaArrowAltCircleRight } from 'react-icons/fa';
import moment from 'moment';
function CalcularEdad(date){
            return moment().diff(date, 'years');
        }
export default function SSVFuerzaTrabajo() {
    const { token } = useAuth();
    const { idEncuesta, idPersona } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [edad, setEdad] = useState('');
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const fetchData = async (idPersona, idEncuesta) => {
        let url = `/encuestassv/fuerzatrabajo/crearformulariopfuerzatrabajo`;
        let obj = { idPersona: idPersona, idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;

            resetForm(result.datosFuerzaTrabajo);
            console.log('Datos de fuerza de trabajo obtenidos:', result);
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos de fuerza de trabajo de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };

    const resetForm = (data) => {
        if (data) {
            reset((prevValues) => ({
                ...prevValues,
                id: data.id || '',
                cons_ficha_id: data.cons_ficha_id || '',
                nombre: data.nombre || '',
                edad_calculada: data.edad_calculada || '',
                fuerzatrabajo1actividadocupomastiempo: data.fuerzatrabajo1actividadocupomastiempo || '',
                fuerzatrabajo2cualactividad: data.fuerzatrabajo2cualactividad || '',
                fuerzatrabajo3realizoactividadpaga: data.fuerzatrabajo3realizoactividadpaga || '',
                fuerzatrabajo6estabadisponiblealguntrabajo: data.fuerzatrabajo6estabadisponiblealguntrabajo || '',
                fuerzatrabajo7tienecontrato: data.fuerzatrabajo7tienecontrato || '',
                fuerzatrabajo8tipotrabajo: data.fuerzatrabajo8tipotrabajo || '',
                fuerzatrabajo9cual: data.fuerzatrabajo9cual || '',
                fuerzatrabajo10queoficioprofesionactual: data.fuerzatrabajo10queoficioprofesionactual || '',
                fuerzatrabajo11recibioingresosenmes: data.fuerzatrabajo11recibioingresosenmes || '',
                fuerzatrabajo12cuanto: data.fuerzatrabajo12cuanto || '',
                fuerzatrabajo13recibiohorasextra: data.fuerzatrabajo13recibiohorasextra || '',
                fuerzatrabajo14cuantorecibio: data.fuerzatrabajo14cuantorecibio || '',
                fuerzatrabajo15incluyovalorendineroanterio: data.fuerzatrabajo15incluyovalorendineroanterio || '',
                fuerzatrabajo16recibioalimentospago: data.fuerzatrabajo16recibioalimentospago || '',
                fuerzatrabajo17cuanto: data.fuerzatrabajo17cuanto || '',
                fuerzatrabajo18recibioviviendapago: data.fuerzatrabajo18recibioviviendapago || '',
                fuerzatrabajo19acuanto: data.fuerzatrabajo19acuanto || '',
                fuerzatrabajo20otrosbonospago: data.fuerzatrabajo20otrosbonospago || '',
                fuerzatrabajo21acuanto: data.fuerzatrabajo21acuanto || '',
                fuerzatrabajo2212mesesprima: data.fuerzatrabajo2212mesesprima || '',
                fuerzatrabajo23acuanto: data.fuerzatrabajo23acuanto || '',
                fuerzatrabajo2412mesesprimanavidad: data.fuerzatrabajo2412mesesprimanavidad || '',
                fuerzatrabajo25cuanto: data.fuerzatrabajo25cuanto || '',
                fuerzatrabajo26primavacaciones: data.fuerzatrabajo26primavacaciones || '',
                fuerzatrabajo27cuanto: data.fuerzatrabajo27cuanto || '',
                fuerzatrabajo28viaticos: data.fuerzatrabajo28viaticos || '',
                fuerzatrabajo29cuanto: data.fuerzatrabajo29cuanto || '',
                fuerzatrabajo30pagoaccidentes: data.fuerzatrabajo30pagoaccidentes || '',
                fuerzatrabajo31cuanto: data.fuerzatrabajo31cuanto || '',
                fuerzatrabajo32ganancianeta: data.fuerzatrabajo32ganancianeta || '',
                fuerzatrabajo33queoficioprofesionactual2: data.fuerzatrabajo33queoficioprofesionactual2 || '',
                fuerzatrabajo34recibioacuantosmeses: data.fuerzatrabajo34recibioacuantosmeses || '',
                fuerzatrabajo35cotizapensiones: data.fuerzatrabajo35cotizapensiones || '',
                fuerzatrabajo36teniaotrotrabajo: data.fuerzatrabajo36teniaotrotrabajo || '',
                fuerzatrabajo37tiposegundotrabajo: data.fuerzatrabajo37tiposegundotrabajo || '',
                fuerzatrabajo38cual: data.fuerzatrabajo38cual || '',
                fuerzatrabajo39cuantorecibio: data.fuerzatrabajo39cuantorecibio || '',
            }))
            setEdad(CalcularEdad(data.datos_basicos_fecha_nacimiento));
        }
    }
    
    useEffect(() => {
        fetchData(idPersona, idEncuesta);
    }, [idPersona, idEncuesta]);

    async function GuardarDatosFuerzaTrabajo() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/fuerzatrabajo/guardardatosfuerzatrabajo`;
        
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de fuerza de trabajo de la persona.');
            }
        })
        .catch(error => {
            if (error.response.data.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de fuerza de trabajo de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }
  
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Personas Fuerza de trabajo</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Fuerza de trabajo</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuPersonasSSV idEncuesta={idEncuesta} idPersona={idPersona}></MenuPersonasSSV>
                    <hr />
                    <Form onSubmit={handleSubmit(GuardarDatosFuerzaTrabajo)}>
                        <Card>
                            <CardHeader>
                                <h3 className="card-title"><b>Fuerza de trabajo totales ingresos</b></h3>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                        <label htmlFor="txtsuma_total_ingresos">Total ingresos de la familia</label>
                                        <input readOnly className="form-control" id="txtsuma_total_ingresos" type="text"/>
                                        </div>  
                                    </Col>  
                                    <Col md={4}>
                                        <div className="form-group">
                                        <label htmlFor="txtingreso_percapita">Ingreso percapita de la familia</label>
                                        <input readOnly className="form-control" id="txtingreso_percapita" type="text"/>
                                        </div>  
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                        <label htmlFor="txtsemaforoftrabajo">Valoracion lp-lpe</label>
                                        <input readOnly className="form-control" id="txtsemaforoftrabajo" type="text"/>
                                        </div>  
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                <h2>Aplica para todas las personas de 10 años y mas, para menores de 15 años, contesta el informante idóneo</h2>
                                <b>Ojo: No diligencie cada pregunta para todos los miembros del hogar a la vez. Diligencie todas las preguntas del capitulo para la persona 1 y continue asimismo con las demas personas.</b>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={2}>
                                    <div className="form-group">
                                        <Form.Label htmlFor="id">id</Form.Label>
                                        <Form.Control readOnly id="id" placeholder="id" type="text" {...register("id")}/>
                                        </div>  
                                    </Col>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label htmlFor="nombre">Nombre de la persona</Form.Label>
                                        <Form.Control readOnly id="nombre" placeholder="Nombre" type="text" {...register("nombre")}/>
                                    </div>
                                    </Col>
                                    <Col md={2}>
                                    <div className="form-group">
                                        <Form.Label htmlFor="edad">Edad</Form.Label>
                                        <Form.Control readOnly id="edad" placeholder="Edad" type="text" value={edad}/>
                                    </div>
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>1. En qué actividad ocupó... la mayor parte del tiempo la semana pasada?</Form.Label>
                                        <Form.Control as="select" 
                                            id="fuerzatrabajo1actividadocupomastiempo" 
                                            style={{width: "100%"}}
                                            {...register("fuerzatrabajo1actividadocupomastiempo")}>
                                        <option value="0" ></option>
                                        <option value="1">1. Trabajando (Pase a pregunta 4)</option>
                                        <option value="2">2. Buscando trabajo</option>
                                        <option value="3">3. Estudiando</option>
                                        <option value="4">4. Oficios del hogar</option>
                                        <option value="5">5. Incapacitado permanente para trabajar (Pase a "Otros ingresos")</option>
                                        <option value="6">6. Otra actividad ¿Cuál?</option>
                                        </Form.Control>
                                        <Form.Control id="txtfuerzaTrabajol1aCualActividad_" placeholder="¿cuál?" type="text" />
                                        <div className="dersuperado">
                                        <button id="geningresosseguimiento" type="button" className="btn btn-primary btn-xs" data-toggle="modal" data-target="#modal-seguimientoderecho">
                                            Superación del derecho
                                        </button>
                                        </div>
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>2. Además de lo anterior, ¿... realizó la semana pasada alguna actividad paga por una hora o más o tuvo algún trabajo o negocio por el que recibio ingresos?</Form.Label>
                                        <Form.Control as="select" 
                                            id="fuerzatrabajo2cualactividad" 
                                            style={{width: "100%"}} 
                                            {...register("fuerzatrabajo2cualactividad")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si, pase a la pregunta 4.</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>3. Si le hubiera resultado algún trabajo a...¿Estaba disponible la semana pasada para empezar a trabajar?</Form.Label>
                                        <Form.Control as="select" 
                                            id="fuerzatrabajo3realizoactividadpaga" 
                                            style={{width: "100%"}}
                                            {...register("fuerzatrabajo3realizoactividadpaga")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                        <p>Pase a "Otros ingresos"</p>
                                    </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>4. ¿Para realizar este trabajo, tiene algún tipo de contrato?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo7tienecontrato" style={{width: "100%"}} {...register("fuerzatrabajo7tienecontrato")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Verbal</option>
                                        <option value="2">2. Escrito</option>
                                        <option value="3">3. No tiene Contrato</option>
                                        </Form.Control>
                                    </div>
                                    </Col> 
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>5. En este trabajo...es: </Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo8tipotrabajo" style={{width: "100%"}} {...register("fuerzatrabajo8tipotrabajo")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Obrero o empleado de empresa particular</option>
                                        <option value="2">2. Obrero o empleado del gobierno</option>
                                        <option value="3">3. Empleado doméstico</option>
                                        <option value="4">4. Trabajador por cuenta propia (Pase a pregunta 15)</option>
                                        <option value="5">5. Patrón o empleador (Pase a pregunta 15)</option>
                                        <option value="6">6. Trabajador familiar sin remuneración (Pase a pregunta 18)</option>
                                        <option value="7">7. Trabajador sin remuneración en empresas o negocios de otros hogares (Pase a pregunta 18)</option>
                                        <option value="8">8. Jornalero o peón</option>
                                        <option value="9">9. Otro, Cuál?</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo9cual" placeholder="Cual" type="text" {...register("fuerzatrabajo9cual")} />
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>6. ¿Qué oficio o profesión DESEMPEÑA... actualmente en este trabajo?</Form.Label>
                                        <Form.Control as="textarea" id="fuerzatrabajo10queoficioprofesionactual" rows="3" placeholder="Oficio" {...register("fuerzatrabajo10queoficioprofesionactual")} />
                                        <p>Nota: Describa lo mejor posible y en letra clara la ocupación de cada persona.</p>
                                    </div>   
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>7. ¿Recibió o ganó en el mes pasado ingresos por concepto de trabajo?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo11recibioingresosenmes" style={{width: "100%"}} {...register("fuerzatrabajo11recibioingresosenmes")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                    </div>
                                    </Col>
                                </Row>
                                <Row>  
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label htmlFor="fuerzatrabajo12cuanto">8. ¿Cuánto recibió o ganó el mes pasado en este empleo?</Form.Label>
                                        <Form.Control id="fuerzatrabajo12cuanto" placeholder="Valor Mensual ($)" type="text" {...register("fuerzatrabajo12cuanto")} />
                                        <p>Notas: Si no recibió salario en dinero, registre 00.</p>
                                        <p>Notas: Si recibió pero no sabe el monto, registre 98.</p>
                                        <p>Notas: Si no informa el monto que recibió, registre 99.</p>
                                    </div>  
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>9. ¿El mes pasado... recibió ingresos por concepto de horas extras?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo13recibiohorasextra" style={{width: "100%"}} {...register("fuerzatrabajo13recibiohorasextra")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No (Pase a pregunta 11)</option>
                                        <option value="98">98 No Sabe, No informa (Pase a pregunta 11)</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo14cuantorecibio" placeholder="Cuanto" type="text" {...register("fuerzatrabajo14cuantorecibio")} />
                                        <p>Si recibió pero no sabe el monto, registre 98</p>
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>10. ¿Incluyó este valor en los ingresos del mes pasado ($___) que me declaró anteriormente?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo15incluyovalorendineroanterio" style={{width: "100%"}} {...register("fuerzatrabajo15incluyovalorendineroanterio")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        </Form.Control>
                                    </div>
                                    </Col>
                                </Row>
                                <Row>  
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>11.Además del salario en dinero, ¿el mes pasado recibió alimentos como parte de pago por su trabajo?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo16recibioalimentospago" style={{width: "100%"}} {...register("fuerzatrabajo16recibioalimentospago")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. No sabe/ No informa</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo17cuanto" placeholder="Cuanto estima lo que recibió" type="text" {...register("fuerzatrabajo17cuanto")} />
                                        <p>Si recibió pero no sabe el monto, registre 98</p>
                                    </div>
                                    </Col>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>12.Además del salario en dinero, ¿el mes pasado recibió vivienda como parte de pago por su trabajo?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo18recibioviviendapago" style={{width: "100%"}} {...register("fuerzatrabajo18recibioviviendapago")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. No sabe/ No informa</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo19acuanto" placeholder="Cuanto estima lo que recibió" type="text" {...register("fuerzatrabajo19acuanto")} />
                                        <p>Si recibió pero no sabe el monto, registre 98</p>
                                    </div>
                                    </Col>
                                    <Col md={4}>
                                    <div className="form-group">
                                        <Form.Label>13. Ademas del salario en dinero, ¿el mes pasado recibio otros ingresos en especie por su trabajo (Electrodomésticos, vestidos, otros productos diferentes a alimentos o bonos como Sodexo)?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo20otrosbonospago" style={{width: "100%"}} {...register("fuerzatrabajo20otrosbonospago")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. No sabe/ No informa</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo21acuanto" placeholder="Cuanto estima lo que recibió" type="text" {...register("fuerzatrabajo21acuanto")} />
                                        <p>Si recibió pero no sabe el monto, registre 98</p>
                                    </div>
                                    </Col>
                                </Row>
                                <Row>  
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label><b>14. En los últimos 12 meses … recibió</b></Form.Label>
                                    </div> 
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>a. ¿Prima de servicios?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo2212mesesprima" style={{width: "100%"}} {...register("fuerzatrabajo2212mesesprima")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. Si recibió pero no sabe estimar</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo23acuanto" placeholder="Cuanto" type="text" {...register("fuerzatrabajo23acuanto")} />
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>b. ¿Prima de navidad?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo2412mesesprimanavidad" style={{width: "100%"}} {...register("fuerzatrabajo2412mesesprimanavidad")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. Si recibió pero no sabe estimar</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo25cuanto" placeholder="Cuanto" type="text" {...register("fuerzatrabajo25cuanto")} />
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>c. ¿Prima de vacaciones?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo26primavacaciones" style={{width: "100%"}} {...register("fuerzatrabajo26primavacaciones")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. Si recibió pero no sabe estimar</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo27cuanto" placeholder="Cuanto" type="text" {...register("fuerzatrabajo27cuanto")} />
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>d. ¿Viáticos permanentes y/o bonificaciones anuales?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo28viaticos" style={{width: "100%"}} {...register("fuerzatrabajo28viaticos")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. Si recibió pero no sabe estimar</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo29cuanto" placeholder="Cuanto" type="text" {...register("fuerzatrabajo29cuanto")} />
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>e. ¿Pagos por accidentes de trabajo?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo30pagoaccidentes" style={{width: "100%"}} {...register("fuerzatrabajo30pagoaccidentes")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. Si recibió pero no sabe estimar</option>
                                        </Form.Control>
                                        <Form.Control id="fuerzatrabajo31cuanto" placeholder="Cuanto" type="text" {...register("fuerzatrabajo31cuanto")} />
                                        <p>Pase a la pregunta 18</p>
                                    </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label><b>INDEPENDIENTES</b></Form.Label>
                                    </div> 
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label htmlFor="fuerzatrabajo32ganancianeta">15.¿Cuánto fue la ganancia neta o los honorarios netos de …en esa actividad, negocio, profesión o finca, el mes pasado?</Form.Label>
                                        <Form.Control id="fuerzatrabajo32ganancianeta" placeholder="Ganancia" type="text" {...register("fuerzatrabajo32ganancianeta")} />
                                        <p>Notas: Si no obtuvo ganancias, registre 00.</p>
                                        <p>Notas: Si obtuvo pero no sabe el monto, registre 98.</p>
                                        <p>Notas: Si no informa si obtuvo, registre 99.</p>
                                        </div>  
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>16. ¿Qué oficio o profesión DESEMPEÑA... actualmente en este trabajo?</Form.Label>
                                        <Form.Control as="textarea" id="fuerzatrabajo33queoficioprofesionactual2" rows="3" placeholder="Oficio" {...register("fuerzatrabajo33queoficioprofesionactual2")} />
                                        <p>Nota: Describa lo mejor posible y en letra clara la ocupacion de cada persona.</p>
                                    </div>   
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label htmlFor="fuerzatrabajo34recibioacuantosmeses">17. ¿A cuántos meses corresponde lo que recibió?</Form.Label>
                                        <Form.Control id="fuerzatrabajo34recibioacuantosmeses" placeholder="Cuantos" type="text" {...register("fuerzatrabajo34recibioacuantosmeses")} />
                                        </div>  
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                    <div className="form-group">
                                        <Form.Label><b>TODOS LOS OCUPADOS</b></Form.Label>
                                    </div> 
                                    </Col>  
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>18. ¿Está … cotizando actualmente a un fondo de pensiones?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo35cotizapensiones" style={{width: "100%"}} {...register("fuerzatrabajo35cotizapensiones")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No</option>
                                        <option value="98">98. Ya está pensionado</option>
                                        </Form.Control>
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>19. Además de la ocupación principal, ¿tenía la semana pasada otro trabajo o negocio?</Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo36teniaotrotrabajo" style={{width: "100%"}} {...register("fuerzatrabajo36teniaotrotrabajo")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Si</option>
                                        <option value="2">2. No (Pase a "Otros ingresos")</option>
                                        </Form.Control>
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label>20. En ese segundo trabajo es: </Form.Label>
                                        <Form.Control as="select" id="fuerzatrabajo37tiposegundotrabajo" style={{width: "100%"}} {...register("fuerzatrabajo37tiposegundotrabajo")}>
                                        <option value="0" hidden ></option>
                                        <option value="1">1. Obrero o empleado de empresa particular</option>
                                        <option value="2">2. Obrero o empleado del gobierno</option>
                                        <option value="3">3. Empleado doméstico</option>
                                        <option value="7">4. Trabajador por cuenta propia</option>
                                        <option value="5">5. Patrón o empleador</option>
                                        <option value="6">6. Trabajador familiar sin remuneración</option>
                                        <option value="7">7. Trabajador sin remuneración</option>
                                        <option value="8">8. Jornalero o peón</option>
                                        <option value="9">9. Otro, ¿Cual?</option>
                                        </Form.Control>
                                        <Form.Control type="text" id="fuerzatrabajo38cual" placeholder="Cual" {...register("fuerzatrabajo38cual")} />
                                    </div>
                                    </Col>
                                    <Col md={3}>
                                    <div className="form-group">
                                        <Form.Label htmlFor="fuerzatrabajo39cuantorecibio">21. ¿Cuantó recibío o ganó el mes pasado en ese segundo trabajo o negocio? Valor mensual $ </Form.Label>
                                        <Form.Control id="fuerzatrabajo39cuantorecibio" placeholder="Ganancia" type="text" {...register("fuerzatrabajo39cuantorecibio")} />
                                        </div>  
                                    </Col>
                                </Row>  
                            </CardBody>
                            <CardFooter>
                                <div className="d-flex flex-wrap align-items-center" style={{ gap: '12px' }}>
                                    <Button type='submit' id="Guardar" className="btn btn-primary">
                                        <FaSave />
                                        Guardar
                                    </Button>
                                    <Button 
                                        id="Cancelar" 
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            globalThis.location.href = `/encuestassv/id/${idEncuesta}`;
                                        }
                                        }>
                                        <FaArrowAltCircleRight />
                                        Volver
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Form>
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }